import React, { useState, useEffect } from "react";
import "../imageComponent.css";

const images = [
  "/assets/images/1921.png",
  "/assets/images/1922.png",
  "/assets/images/1923.png",
  "/assets/images/1924.png",
  "/assets/images/1925.png",
  "/assets/images/1926.png",
  "/assets/images/1927.png",
  "/assets/images/1928.png",
  "/assets/images/1929.png"
];

const ImageComponent = () => {
  const [currentIndex, setCurrentIndex] = useState(
    Math.floor(Math.random() * images.length)
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000); // every 1 second

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="image-component-container">
      <div className="image-component-text-h1">
        <div className="image-component-text-h1-h1">
          Let's Make Your UPSC Prep Stress-Free
        </div>
        <div className="image-component-text-h1-h2">
          Smart preparation beats hard preparation. Let's tailor your study plan!
        </div>
      </div>
      <img
        src="/assets/images/onbordong-image-style.svg"
        alt="star"
        className="c2-img-style"
      />
      <div className="image-component-text-topic">
        <p>
          <span>
            <img src="/assets/images/Lamp_light.svg" alt="star" />
          </span>
          Topic Summaries, Subject matter Q&A
        </p>
        <p>
          <span>
            <img src="/assets/images/Done_ring_round_light.svg" alt="star" />
          </span>
          Mains Evaluation
        </p>
        <p>
          <span>
            <img src="/assets/images/Book_check_light.svg" alt="star" />
          </span>
          Personalized Study Plans
        </p>
        <p>
          <span>
            <img src="/assets/images/File_dock_search_light.svg" alt="star" />
          </span>
          Prelims and Mains PYQs
        </p>
        <p>
          <span>
            <img src="/assets/images/Book_open_light.svg" alt="star" />
          </span>
          Daily News Summaries
        </p>
        <p>
          <span>
            <img src="/assets/images/User_cicrle_light.svg" alt="star" />
          </span>
          Smart Mentor Assistance
        </p>
      </div>

      <div className="image-component-count">
        <div className="image-component-count-left">
          <span className="count-h1">120+</span>
          <span className="count-p1">Topics Covered for UPSC</span>
        </div>
        <div className="image-component-count-right">
          <span className="count-h1">100k+</span>
          <span className="count-p1">Queries Resolved</span>
        </div>
      </div>

      {/* This is the image that changes every second */}
      <img
        src={images[currentIndex]}
        alt="dynamic"
        className="bottom-img"
      />
    </div>
  );
};

export default ImageComponent;
